/* Keep paired stain-resistant coating lines in sync with their parent rug. */
(function () {
  'use strict';

  var syncing = false;
  var timer = null;
  var lastSignature = '';

  function localized(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function property(item, name) {
    return item && item.properties ? item.properties[name] : undefined;
  }
  function isCoating(item) { return property(item, '_is_coating') === 'yes'; }
  function pairKey(item) { return property(item, '_parent_key'); }

  function signature(cart) {
    return (cart.items || []).filter(pairKey).map(function (item) {
      return (isCoating(item) ? 'c:' : 'r:') + pairKey(item) + ':' + item.quantity;
    }).sort().join('|');
  }

  function fetchCart() {
    return fetch(localized('/cart.js'), {
      headers: { Accept: 'application/json' }, credentials: 'same-origin'
    }).then(function (response) { return response.json(); });
  }

  function changeLine(key, quantity) {
    return fetch(localized('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) { return response.json(); });
  }

  function reconcile(cart) {
    if (syncing || !cart) return Promise.resolve();
    var sig = signature(cart);
    if (sig === lastSignature) return Promise.resolve();
    lastSignature = sig;
    if (!sig) return Promise.resolve();

    var rugQty = {};
    var coatings = {};
    (cart.items || []).forEach(function (item) {
      var key = pairKey(item);
      if (!key) return;
      if (isCoating(item)) (coatings[key] = coatings[key] || []).push(item);
      else rugQty[key] = Math.max(rugQty[key] || 0, item.quantity);
    });

    var operations = [];
    Object.keys(coatings).forEach(function (key) {
      coatings[key].forEach(function (coating) {
        var quantity = rugQty[key] || 0;
        if (coating.quantity !== quantity) operations.push({ key: coating.key, quantity: quantity });
      });
    });
    if (!operations.length) return Promise.resolve();

    syncing = true;
    return operations.reduce(function (promise, operation) {
      return promise.then(function () { return changeLine(operation.key, operation.quantity); });
    }, Promise.resolve()).then(function (updatedCart) {
      syncing = false;
      lastSignature = signature(updatedCart || cart);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function (error) {
      syncing = false;
      console.warn('[cart-sync] Could not sync coating line:', error);
    });
  }

  function schedule(cart) {
    if (syncing) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (cart && Array.isArray(cart.items)) reconcile(cart);
      else fetchCart().then(reconcile).catch(function () {});
    }, cart ? 0 : 80);
  }

  // Reuse the result of the theme's update when it includes Ajax cart items;
  // otherwise perform one fresh read. There is no DOM observer or self-loop.
  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(function (result) {
        if (result && result.detail && Array.isArray(result.detail.items)) {
          schedule({ items: result.detail.items });
        } else {
          schedule(result && result.cart);
        }
      }).catch(function () {});
    } else schedule();
  });
  document.addEventListener('on:cart:update', function () { schedule(); });

  function initialCheck() {
    // Most sessions have no paired add-on. Avoid a page-load cart request
    // unless the server-rendered cart drawer actually contains a paired line.
    if (document.querySelector('[data-piecraft-pair]')) schedule();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialCheck, { once: true });
  } else initialCheck();
})();
